import * as React from 'react';

import { Tooltip } from '@blockworks/ui';

import SortChevron from '@/components/pages/grants/components/sort-chevron';
import type { RequestSort, SortConfig } from '@/utils/hooks/use-sortable-data';

export const SortableTh = ({
    className,
    identifier,
    sortConfig,
    requestSort,
    title,
    tooltipText = '',
    center = false,
}: {
    className?: string;
    identifier: string;
    sortConfig: SortConfig | null;
    requestSort: RequestSort;
    title: string;
    tooltipText?: React.ReactNode | string;
    center?: boolean;
}) => (
    <th role="button" className={`cursor-pointer select-none ${className}`} onClick={() => requestSort(identifier)}>
        <div className={`flex h-full gap-1 ${center ? 'justify-center items-center' : 'justify-start'}`}>
            {tooltipText ? (
                <Tooltip
                    contentText={
                        <div className="prose max-w-44 break-words text-xs font-normal text-black">{tooltipText}</div>
                    }
                    side="top"
                    align="start"
                >
                    <Tooltip.Trigger>{title}</Tooltip.Trigger>
                </Tooltip>
            ) : (
                <span>{title}</span>
            )}
            {sortConfig?.key === identifier && <SortChevron direction={sortConfig.direction} />}
        </div>
    </th>
);
